// Shared TargetingList field metadata — match_field options + match_type
// labels. Extracted from TargetingLists.js so ClientListImportWizard.js (a
// component, not a page) can build the same "new target list" fields without
// importing across the components/pages boundary or duplicating this logic a
// second place.

// The Lead columns the existing F4 checks (geo/segment/industry/TAL) actually
// key off of — surfaced first, and labeled as such, since they're the field
// almost every list creator wants. Everything else in the master Lead field
// list (GET /leads/export-fields) is still selectable via search, for custom
// list types that validate against some other lead column.
export const SUGGESTED_MATCH_FIELDS = [
  { value: 'state',        label: 'State (suggested)' },
  { value: 'country',      label: 'Country (suggested)' },
  { value: 'segment',      label: 'Segment (suggested)' },
  { value: 'industry',     label: 'Industry (suggested)' },
  { value: 'company_name',   label: 'Company Name (suggested)' },
  { value: 'company_domain', label: 'Company Domain (suggested)' },
  { value: 'email',          label: 'Email (suggested)' },
];

// Build the full match-field option list: suggested fields first, then every
// other field from the master Lead field list, then — if a currently-set
// value predates this fixed set — that legacy value too, so it's never
// silently blanked/lost.
export function buildMatchFieldOptions(allLeadFields, currentValue) {
  const suggestedValues = new Set(SUGGESTED_MATCH_FIELDS.map(o => o.value));
  const rest = (allLeadFields || [])
    .filter(f => !suggestedValues.has(f.key))
    .map(f => ({ value: f.key, label: `${f.label} · ${f.group}` }));
  const options = [...SUGGESTED_MATCH_FIELDS, ...rest];
  if (currentValue && !options.some(o => o.value === currentValue)) {
    options.push({ value: currentValue, label: currentValue });
  }
  return options;
}

export const MATCH_TYPES = {
  exact: 'Exact match',
  case_insensitive: 'Case-insensitive',
  contains: 'Contains',
  fuzzy: 'Fuzzy (handles misspellings)',
};
